import { h } from 'preact'
import TopicReplyCount from '../../control-components/ui-components/TopicReplyCount'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  lastPostUrl: string,
  numberOfReplies: number,
  numberOfUnreadReplies?: number,
  id: string
}

const TopicComments = ({ lastPostUrl, numberOfReplies, numberOfUnreadReplies, id }: Props) => {
  return (
    <span className='thread-meta-item thread-meta-item--comments thread-meta-item--hover-highlight'>
      <a className='qa-topic-meta-replies-icon' href={lastPostUrl}>
        <TopicReplyCount replyCount={numberOfReplies} />
      </a>

      {
        numberOfUnreadReplies ? (
          <span className='thread-meta-item__text thread-meta-bullet'>
            <span className='icon--bullet icon--auto-width' />
          </span>) : null
      }

      {
        numberOfUnreadReplies ? (
          <a
            className='thread-meta-item__text--highlight qa-topic-meta-new'
            href={`/topic/firstNewPostRedirect?topicId=${id}`}
          >
            <span className='thread-meta-item__text--highlight'>
              <Phrase p='forumList.meta.counter.post.user.new' count={{ n: numberOfUnreadReplies.toString() }} />
            </span>
          </a>) : null
      }
    </span>
  )
}

export default TopicComments
